module.exports = __webpack_public_path__ + "static/media/1017088.b2c79054.png";